import { render, staticRenderFns } from "./GroupPermissionsTab.vue?vue&type=template&id=57b170d7&scoped=true&"
import script from "./GroupPermissionsTab.vue?vue&type=script&lang=ts&"
export * from "./GroupPermissionsTab.vue?vue&type=script&lang=ts&"
import style0 from "./GroupPermissionsTab.vue?vue&type=style&index=0&id=57b170d7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b170d7",
  null
  
)

export default component.exports